import { render, staticRenderFns } from "./TraderLevel.vue?vue&type=template&id=16f9728f&scoped=true&"
import script from "./TraderLevel.vue?vue&type=script&lang=js&"
export * from "./TraderLevel.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=16f9728f&lang=less&scoped=true&"
import style1 from "./TraderLevel.vue?vue&type=style&index=1&id=16f9728f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f9728f",
  null
  
)

export default component.exports